export const mockRegistriaUserToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9';
